import vtkCompositeCameraManipulator from './CompositeCameraManipulator';
import vtkCompositeGestureManipulator from './CompositeGestureManipulator';
import vtkCompositeKeyboardManipulator from './CompositeKeyboardManipulator';
import vtkCompositeMouseManipulator from './CompositeMouseManipulator';
import vtkCompositeVRManipulator from './CompositeVRManipulator';
import vtkGestureCameraManipulator from './GestureCameraManipulator';
import vtkKeyboardCameraManipulator from './KeyboardCameraManipulator';
import vtkMouseBoxSelectorManipulator from './MouseBoxSelectorManipulator';
import vtkMouseCameraAxisRotateManipulator from './MouseCameraAxisRotateManipulator';
import vtkMouseCameraSliceManipulator from './MouseCameraSliceManipulator';
import vtkMouseCameraUnicamManipulator from './MouseCameraUnicamManipulator';
import vtkMouseCameraUnicamRotateManipulator from './MouseCameraUnicamRotateManipulator';
import vtkMouseCameraTrackballFirstPersonManipulator from './MouseCameraTrackballFirstPersonManipulator';
import vtkMouseCameraTrackballMultiRotateManipulator from './MouseCameraTrackballMultiRotateManipulator';
import vtkMouseCameraTrackballPanManipulator from './MouseCameraTrackballPanManipulator';
import vtkMouseCameraTrackballRollManipulator from './MouseCameraTrackballRollManipulator';
import vtkMouseCameraTrackballRotateManipulator from './MouseCameraTrackballRotateManipulator';
import vtkMouseCameraTrackballZoomManipulator from './MouseCameraTrackballZoomManipulator';
import vtkMouseCameraTrackballZoomToMouseManipulator from './MouseCameraTrackballZoomToMouseManipulator';
import vtkMouseRangeManipulator from './MouseRangeManipulator';
import vtkVRButtonPanManipulator from './VRButtonPanManipulator';

export default {
  vtkCompositeCameraManipulator,
  vtkCompositeGestureManipulator,
  vtkCompositeKeyboardManipulator,
  vtkCompositeMouseManipulator,
  vtkCompositeVRManipulator,
  vtkGestureCameraManipulator,
  vtkKeyboardCameraManipulator,
  vtkMouseBoxSelectorManipulator,
  vtkMouseCameraAxisRotateManipulator,
  vtkMouseCameraSliceManipulator,
  vtkMouseCameraUnicamManipulator,
  vtkMouseCameraUnicamRotateManipulator,
  vtkMouseCameraTrackballFirstPersonManipulator,
  vtkMouseCameraTrackballMultiRotateManipulator,
  vtkMouseCameraTrackballPanManipulator,
  vtkMouseCameraTrackballRollManipulator,
  vtkMouseCameraTrackballRotateManipulator,
  vtkMouseCameraTrackballZoomManipulator,
  vtkMouseCameraTrackballZoomToMouseManipulator,
  vtkMouseRangeManipulator,
  vtkVRButtonPanManipulator,
};
